export default "__VITE_ASSET__87af82c3__"